<template>
  <a-modal
    title="问题归纳"
    v-model:visible="visible"
    width="1000px"
    :okButtonProps="{
      disabled: selectedRowKeys.length === 0,
    }"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="closed-loop-problem">
      <div style="margin-bottom: 10px" class="df both-side">
        <a-space>
          <a-select
            v-model:value="requestPayload.project"
            placeholder="项目"
            :options="rndProject"
            @change="getData"
            allowClear
            style="width: 120px"
          ></a-select>
          <a-select
            v-model:value="requestPayload.examine"
            :options="examineStatus"
            placeholder="审核状态"
            @change="getData"
            style="width: 120px"
            allowClear
          ></a-select>
          <a-select
            v-model:value="requestPayload.status"
            :options="closedLoopStatusOptions"
            placeholder="问题清单状态"
            @change="getData"
            style="width: 140px"
            allowClear
          ></a-select>
        </a-space>
      </div>
      <a-table
        :data-source="table.data"
        bordered
        :pagination="false"
        :columns="columns"
        rowKey="id"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onSelect: onSelectChange,
          type: 'radio',
        }"
      >
        <template #serialNumber="{ record }">
          <template
            v-if="
              record.serialNumber && record.serialNumber.indexOf('[') !== -1
            "
          >
            <template
              v-for="serial in JSON.parse(record.serialNumber)"
              :key="serial"
            >
              <a-tag style="margin-bottom: 2px">{{ serial }}</a-tag>
            </template>
          </template>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useTable } from "@/views/notice/serve/table";
import {
  getProjectProblemClosedLoop,
  problemInduction,
} from "@/request/view/trialProductionCenter";
import {
  initRnDProject,
  rndProject,
  examineStatus,
  rndFiledNames,
  closedLoopStatusOptions,
} from "@/views/trialProductionCenter/closedLoopProblem/serve";
import { Toast } from "@/utils";

export default defineComponent({
  components: {},
  setup() {
    const { requestConfig, table, requestPayload, initPayload, getListData } =
      useTable();

    initPayload({
      examine: null,
      project: null,
      status: null,
    });

    const selectedRowKeys = ref([]);

    const visible = ref(false);

    let serialNumber = null;

    const columns = [
      {
        title: "工序",
        dataIndex: "processes",
        align: "center",
        width: "120px",
      },
      {
        title: "问题流水号",
        slots: {
          customRender: "serialNumber",
        },
        align: "center",
      },
      {
        title: "异常问题描述",
        dataIndex: "abnormalProblemDesc",
        align: "center",
      },
      {
        title: "临时措施",
        dataIndex: "temporaryMeasures",
        align: "center",
      },
      {
        title: "闭环措施",
        dataIndex: "closedLoopMeasures",
        align: "center",
      },
    ];

    requestConfig.pull_fn = getProjectProblemClosedLoop;

    const onSelectChange = (record) => {
      const radioId = record.id;
      const fIndex = selectedRowKeys.value.findIndex((f) => f === radioId);
      console.log(fIndex, radioId);
      selectedRowKeys.value.length = 0;
      if (fIndex === -1) {
        selectedRowKeys.value.push(radioId);
      }
    };

    const handleCancel = () => {
      serialNumber = null;
      selectedRowKeys.value.length = 0;
      visible.value = false;
    };

    const handleOk = () => {
      problemInduction({
        serialNumber,
        projectProblemClosedLoopId: selectedRowKeys.value[0],
      })
        .then((res) => {
          const type = res.code === 200 ? "success" : "warning";

          Toast(type, res.message, 3);
          handleCancel();
        })
        .catch((err) => {
          handleCancel();
        });
    };

    const getData = () => {
      getListData({ unPagingRequest: true });
    };

    initRnDProject();

    const showModal = (record) => {
      serialNumber = record.serialNumber;
      visible.value = true;
      getData();
    };
    return {
      table,
      columns,
      rndProject,
      examineStatus,
      requestPayload,
      selectedRowKeys,
      closedLoopStatusOptions,
      rndFiledNames,
      visible,
      handleCancel,
      handleOk,
      onSelectChange,
      showModal,
      getData,
    };
  },
});
</script>

<style lang="less" scoped>
.closed-loop-problem {
}
</style>
